import React from 'react'
import styled, { css } from 'styled-components'

const CollapsablePanel = ({ title, filter, defaultOpen, children }: any) => {

  const [open, setOpen] = React.useState<boolean>(!!defaultOpen)

  const togglePanel = () => {
    setOpen(!open);
  }

  return (
    <Panel>
      <PanelHeading onClick={togglePanel} {...{ open, filter }}>
        {title}
        <svg width="26" height="13" viewBox="0 0 26 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.35938 1.2428L13.4621 11.9095L25.3594 1.2428" stroke="currentcolor" strokeWidth="1.5" />
        </svg>
      </PanelHeading>
      <PanelContent {...{ open, filter }}>
        {children}
      </PanelContent>
    </Panel>
  )
}

export default CollapsablePanel

export const Panel = styled.div<any>`
  color: var(--text);
  font-size: 14px;
  h3 {
    font-size: 16px;
  }
`
export const PanelHeading = styled.button<any>`
  color: var(--text);
  background: rgba(0,0,0,0);
  font-weight: bold;
  font-size: 16px;
  width: 100%;
  border: 0;
  text-align: left;
  border-bottom: 1px var(--text) solid;
  padding: ${props => props.filter ? '24px' : '24px 0'};
  margin: 0;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${props => !props.filter && css`
    text-transform: uppercase;
  `};
  svg {
    transition: all 350ms ease-in;
    height: ${props => props.filter ? '8px' : 'auto'};
  }
  ${props => props.open && css`
    svg {
      transform: rotate(180deg);
    }
  `};
`

export const PanelContent = styled.div<any>`
  transition: all 350ms ease-in;
  border-bottom: 1px var(--text) solid;
  padding: ${props => props.filter ? '0' : '16px 0'};
  max-height: 100vh;
  overflow: hidden;
  ${props => !props.open && css`
    opacity: 0;
    max-height: 0;
    padding: 0;
  `}
`
